import {
    GET_REGION_REQUEST,
    GET_REGION_SUCCESS,
    GET_REGION_ERROR,

} from "./types"
import axios from "axios";
import { BASEURL } from "../../constant/config.js"


///GET CUSTOMER TYPE
export const loadRegion = (token, id) => dispatch => {
    dispatch({ type: GET_REGION_REQUEST });
    return axios({
        method: "GET",
        url: `${BASEURL}getOne/adminRegion/${id}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {


            return dispatch({ type: GET_REGION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_REGION_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_REGION_ERROR,
                payload: error.response,
            });
        })
};

